import { Avatar, Box, CircularProgress, Fade } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { convertImageToCanvas } from '../../common/util';

const SubUserAvatar = ({ img, src }) => {
  const [url, setURL] = useState(src);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (img) {
      setLoading(true);
      convertImageToCanvas(img).then((data) => {
        setLoading(false);
        const dataURL = data.toDataURL('image/png', 1);
        setURL(dataURL);
      });
    }
  }, [img]);

  return (
    <Box sx={{ position: 'relative' }}>
      {loading && (
        <CircularProgress
          color="secondary"
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            margin: 'auto',
          }}
        />
      )}
      <Fade in={!loading}>
        <Avatar
          src={url || '/image/img_user.png'}
          sx={{ width: 56, height: 56 }}
        />
      </Fade>
    </Box>
  );
};

export default SubUserAvatar;
